export default __webpack_public_path__ + "static/media/AccessDenied.5edfe3e0.png";